import React from 'react';
import "../Donate/Donate.css"

const Request = () => {
  return (
    <div>
        <header className='request-header'>
            <section>
              <h3>Request a donor</h3>
              <p>1 pint of blood will save 3 lives. Every pints Counts </p>
              <button>Coming Soon</button>
            </section>
        </header> 
    </div>
  )
}

export default Request